// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---gatsby-theme-minimal-src-pages-404-js": () => import("./../../../gatsby-theme-minimal/src/pages/404.js" /* webpackChunkName: "component---gatsby-theme-minimal-src-pages-404-js" */),
  "component---gatsby-theme-minimal-src-pages-index-js": () => import("./../../../gatsby-theme-minimal/src/pages/index.js" /* webpackChunkName: "component---gatsby-theme-minimal-src-pages-index-js" */)
}

